var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGdGrenada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7002 6.30005H6.3002V38.7H53.7002V6.30005Z",
    fill: "#007A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7002 6.30933H6.3002L53.7002 38.7093H6.3002L53.7002 6.30933Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0092 27.9094C27.0268 27.9094 24.6092 25.4917 24.6092 22.5094C24.6092 19.527 27.0268 17.1094 30.0092 17.1094C32.9915 17.1094 35.4092 19.527 35.4092 22.5094C35.4092 25.4917 32.9915 27.9094 30.0092 27.9094Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4092 22.5657C49.697 23.8939 48.603 24.978 47.2686 25.6782C47.3206 24.213 47.6816 22.7754 48.3279 21.4595L50.4092 22.5657Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5529 18.2532C50.5779 20.2875 54.0935 25.1625 48.2247 26.3063C49.0172 25.1581 49.3791 23.767 49.2466 22.3782C47.9422 22.9811 46.8718 23.9955 46.1997 25.2657C44.6622 19.6875 50.1372 20.0344 51.5529 18.2532Z",
    fill: "#FCD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdGrenada);
export default __webpack_public_path__ + "static/media/gd Grenada.7c4fb4cd90401128be1ddf32f432ac1e.svg";
export { ForwardRef as ReactComponent };